import { Brand } from '@ptl/brand';

export enum OFF_EXCHANGE_STRATEGIES {
  SHOPX = 'SHOPX',
  HEALTH_SHERPA = 'HEALTH_SHERPA'
}

export interface HealthSherpaAEMConfigItem {
  offExchangeStrategy: OFF_EXCHANGE_STRATEGIES;
  stateOrRegion: string;
}
